module.exports = __webpack_public_path__ + "static/media/summaryCart.a53409df.svg";